"use client";

import RequestPhotosPaymentModal, {
	type RequestPhotosPaymentProperty,
} from "./RequestPhotosPaymentModal";

export interface RequestPhotosModalProps {
	isOpen: boolean;
	onClose: () => void;
	onCloseWithSelection?: (properties: RequestPhotosPaymentProperty[]) => void;
	/**
	 * Single-property compatibility (existing dashboard camera flow).
	 * Prefer `properties` for multi-selection.
	 */
	address?: string;
	propertyId?: string | null;
	city?: string;
	state?: string;
	county?: string;
	zip?: string;
	latitude?: number;
	longitude?: number;
	/**
	 * Multi-property flow (used by the new "Request photos (N)" CTA).
	 */
	properties?: RequestPhotosPaymentProperty[];
	/** Row camera on dashboard: merge into draft and close without replacing draft on close. */
	onAddToOrderAndClose?: (properties: RequestPhotosPaymentProperty[]) => void;
}

export default function RequestPhotosModal({
	isOpen,
	onClose,
	onCloseWithSelection,
	address,
	propertyId,
	city,
	state,
	county,
	zip,
	latitude,
	longitude,
	properties,
	onAddToOrderAndClose,
}: RequestPhotosModalProps) {
	const resolvedProperties: RequestPhotosPaymentProperty[] =
		properties ??
		(propertyId
			? [
					{
						id: String(propertyId),
						address: String(address ?? ""),
						city: String(city ?? ""),
						state: String(state ?? ""),
						county: String(county ?? ""),
						zip: String(zip ?? ""),
						latitude: typeof latitude === "number" ? latitude : 0,
						longitude:
							typeof longitude === "number" ? longitude : 0,
					},
				]
			: []);

	return (
		<RequestPhotosPaymentModal
			isOpen={isOpen}
			onClose={onClose}
			onCloseWithSelection={onCloseWithSelection}
			onAddToOrderAndClose={onAddToOrderAndClose}
			properties={resolvedProperties}
		/>
	);
}
